import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Categories
export const getCategories = () => api.get('/categories');

// Subscription Plans
export const getSubscriptionPlans = () => api.get('/subscription-plans');

// Companies
export const getCompanies = (params) => api.get('/companies', { params });
export const getCompaniesNearby = (params) => api.get('/companies/nearby', { params });
export const getCompany = (id) => api.get(`/companies/${id}`);
export const updateCompany = (data) => api.put('/companies/me', data);
export const uploadCompanyPhoto = (formData) => api.post('/companies/me/photos', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteCompanyPhoto = (photoIndex) => api.delete(`/companies/me/photos/${photoIndex}`);
export const updateCompanyLogo = (logoDataUrl) => api.put('/companies/me/logo', { logo: logoDataUrl });
export const updateCompanyBanner = (bannerDataUrl) => api.put('/companies/me/banner', { banner: bannerDataUrl });

// Chat
export const createConversation = (quoteId) => api.post('/conversations', { quote_id: quoteId });
export const listConversations = () => api.get('/conversations');
export const getConversation = (convId) => api.get(`/conversations/${convId}`);
export const listMessages = (convId) => api.get(`/conversations/${convId}/messages`);
export const sendMessage = (convId, text, attachments = []) => api.post(`/conversations/${convId}/messages`, { conversation_id: convId, text, attachments });

// Notification settings
export const getNotifSettings = () => api.get('/notifications/settings');
export const updateNotifSettings = (settings) => api.put('/notifications/settings', settings);
export const getMyFollowersCount = () => api.get('/follow/my-followers/count');

// Stripe
export const createCheckoutSession = ({ lookup_key, origin_url }) => api.post('/payments/checkout', { lookup_key, origin_url });
export const setupTrialCheckout = ({ origin_url, lookup_key = 'company_basic_monthly' }) =>
  api.post('/stripe/setup-trial', { lookup_key, origin_url });
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`);

// Users
export const updateUser = (data) => api.put('/users/me', data);

// Reviews
export const createReview = (data) => api.post('/reviews', data);
export const getCompanyReviews = (companyId) => api.get(`/reviews/${companyId}`);

// Quote Requests
export const createQuoteRequest = (data) => api.post('/quotes', data);
export const getUserQuotes = () => api.get('/quotes/user');
export const getCompanyQuotes = () => api.get('/quotes/company');
export const updateQuoteStatus = (quoteId, status) => api.put(`/quotes/${quoteId}/status?status=${status}`);

// Payments
export const getPaymentConfig = () => api.get('/payments/config');
export const createPayPalOrder = (planType, tier) => api.post('/payments/create-order', { plan_type: planType, tier });
export const capturePayPalOrder = (orderId) => api.post(`/payments/capture-order/${orderId}`);
export const cancelSubscription = () => api.post('/subscription/cancel');

// Chat
export const sendChatMessage = (message, sessionId, userType) => api.post('/chat', { message, session_id: sessionId, user_type: userType || 'guest' });

// Top rated
export const getTopRated = () => api.get('/companies/top-rated');

// Posts
export const createPost = (data) => api.post('/posts', data);
export const getCompanyPosts = (companyId) => api.get(`/posts/company/${companyId}`);
export const deletePost = (postId) => api.delete(`/posts/${postId}`);

// Stories
export const createStory = (data) => api.post('/stories', data);
export const getCompanyStories = (companyId) => api.get(`/stories/company/${companyId}`);
export const deleteStory = (storyId) => api.delete(`/stories/${storyId}`);

// Follow
export const followCompany = (companyId) => api.post('/follow', { company_id: companyId });
export const unfollowCompany = (companyId) => api.delete(`/follow/${companyId}`);
export const checkFollowing = (companyId) => api.get(`/follow/check/${companyId}`);
export const getMyFollows = () => api.get('/follow/my-follows');
export const getFollowFeed = () => api.get('/follow/feed');

// Leads (automatic matching)
export const createLead = (data) => api.post('/leads', data);
export const getMyLeads = () => api.get('/leads/mine');
export const getIncomingLeads = () => api.get('/leads/incoming');
export const acceptLead = (leadId) => api.post(`/leads/${leadId}/accept`);
export const rejectLead = (leadId) => api.post(`/leads/${leadId}/reject`);
export const chooseLeadCompany = (leadId, companyId) => api.post(`/leads/${leadId}/choose`, { company_id: companyId });

// Notifications
export const getNotifications = () => api.get('/notifications');
export const getUnreadCount = () => api.get('/notifications/unread-count');
export const markNotificationsRead = () => api.post('/notifications/mark-read');
export const toggleNotifications = () => api.post('/notifications/toggle');

export default api;
